import { useCallback } from 'react';

export const useScrollLock = () => {
    const lockScroll = useCallback(() => {
        const scrollBarCompensation = window.innerWidth - document.body.offsetWidth;
        document.body.style.paddingRight = `${scrollBarCompensation}px`;
        document.body.style.overflow = 'hidden';
    }, [])

    const unlockScroll = useCallback(() => {
        document.body.style.paddingRight = '';
        document.body.style.overflow = '';
    }, []);

    return {
        lockScroll,
        unlockScroll
    };
}